import { orderLookupSettingsSchema } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import * as z from "zod";

export const updateOrderLookupSettings = {
  name: "updateOrderLookupSettings" as const,
  input: orderLookupSettingsSchema,
  output: z.object({ success: z.boolean() }),
};
